import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const DeltaBadge = ({ value, delta, style = {} }) => {
  const resolvedValue = value ?? delta;
  if (resolvedValue == null || resolvedValue === undefined) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        color: '#8c8c8c', backgroundColor: '#fafafa', border: '1px solid #e8e8e8',
        borderRadius: 6, fontSize: 12, fontWeight: 700,
        padding: '2px 10px', ...style,
      }}>
        —
      </span>
    );
  }

  const numValue = Number(resolvedValue);
  if (numValue === 0) {
    return (
      <span style={{
        display: 'inline-flex', alignItems: 'center',
        color: '#8c8c8c', backgroundColor: '#fafafa', border: '1px solid #e8e8e8',
        borderRadius: 6, fontSize: 12, fontWeight: 700,
        padding: '2px 10px', ...style,
      }}>
        0.0
      </span>
    );
  }

  const isPositive = numValue > 0;
  const color = isPositive ? '#389e0d' : '#cf1322';
  const bg = isPositive ? '#f6ffed' : '#fff1f0';
  const border = isPositive ? '#b7eb8f' : '#ffa39e';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      color, backgroundColor: bg, border: `1px solid ${border}`,
      borderRadius: 6, fontSize: 12, fontWeight: 700,
      padding: '2px 10px', ...style,
    }}>
      {isPositive ? <ArrowUpOutlined style={{ fontSize: 10 }} /> : <ArrowDownOutlined style={{ fontSize: 10 }} />}
      <span>{isPositive ? `+${numValue.toFixed(1)}` : numValue.toFixed(1)}</span>
    </span>
  );
};

export default DeltaBadge;
